import React from "react";
import { Link } from "react-router-dom";
import "./navbar.css";

function Navbar() {
  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <img src="/sari_kolsi_logo.jpg" alt="Logo" />
      </div>
      <ul className="nav-links">
        <li><Link to="/palvelut">Palvelut</Link></li>
        <li><Link to="/hinnasto">Hinnasto</Link></li>
        <li><Link to="/otayhteytta">Ota yhteyttä</Link></li>
      </ul>
    </nav>
  );
}

export default Navbar;
